module.exports = __webpack_public_path__ + "img/step1.17348449.png";